var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'tooltip-wrapper': true, 'visible': _vm.visible, 'bottom': _vm.position === 'bottom'},on:{"mouseenter":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[_c('div',{staticClass:"tooltip-toggle"},[_vm._t("content")],2),_c('div',{staticClass:"tooltip-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }